import React, { useState, useEffect } from "react";
import { apiCall } from "../../lib/api";

export const AnnouncementTicker = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const data = await apiCall("GET", "/announcements");
        if (Array.isArray(data) && data.length > 0) {
          setItems(data.slice(0, 8));
        }
      } catch {
        setItems([]);
      }
    };
    fetchAnnouncements();
  }, []);

  if (items.length === 0) return null;

  const tickerText = items.map(a => a.title).join("  \u2022  ");
  const doubled = `${tickerText}  \u2022  ${tickerText}`;

  return (
    <div className="bg-[#002147] text-white overflow-hidden relative" data-testid="announcement-ticker">
      <div className="max-w-full flex items-center h-9">
        <div className="flex-shrink-0 bg-red-600 px-3 h-full flex items-center gap-1.5 z-10 shadow-md">
          <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
          <span className="text-xs font-bold uppercase tracking-wider">Live</span>
        </div>
        <div className="overflow-hidden flex-1 relative">
          <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-[#002147] to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-[#002147] to-transparent z-10" />
          <div className="animate-ticker whitespace-nowrap inline-block">
            <span className="text-sm font-medium text-white/90 tracking-wide">{doubled}</span>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          animation: ticker 40s linear infinite;
        }
        .animate-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default AnnouncementTicker;
